import { fabric } from "fabric";
import {handleTemplateZoom, resetZoom} from "@frontend/group/modules/canvas-zoom/init-template-zoom-listeners";
import {ZOOM_TYPE} from "@frontend/group/modules/canvas-zoom/constants";
const UI_BASE = {
  corner: 36, // Doubled from 18 to match the /35 divisor change (was /70, now /35)
};

export default class ZoomService {
  static MAX_CANVAS_SIZE = 4000;
  
  constructor (options) {
    this.containerSelector = options.containerSelector
    this.noZoomSelector = options.noZoomSelector ?? null
    this.onZoom = options.onZoom ?? null
    this.transformOrigin = options.transformOrigin ?? 'top left'
    this.zoom = 100
    this.zoomMax = 100
    this.displayBuilderBaselineZoom = 100
    this.layoutId = $("#template-group-preview").attr("data-layout-id")
    this.restoreZoom()

    this.init()
  }

  get scale () {
    return this.appliedZoom / 100
  }

  get zoomRelative () {
    const val = Math.floor(this.zoom / this.zoomMax * 100)
    return val > 100 && 100 || val < 1 && 1 || val
  }

  getStorageKey() {
    if (!this.layoutId) {
      return null;
    }

    return `zoomValue_${this.layoutId}`;
  }

  hasSavedZoom() {
    const storageKey = this.getStorageKey();
    return !!storageKey && localStorage.getItem(storageKey) !== null;
  }

  get appliedZoom() {
    return window.isDisplayBuilder
      ? this.zoom * (this.displayBuilderBaselineZoom / 100)
      : this.zoom;
  }

  setDisplayBuilderBaselineZoom(zoom = 100) {
    if (!window.isDisplayBuilder) {
      return this;
    }

    const normalizedZoom = Number.parseFloat(zoom);
    this.displayBuilderBaselineZoom = Number.isFinite(normalizedZoom) && normalizedZoom > 0
      ? normalizedZoom
      : 100;

    return this;
  }

  init() {
    this.appendHtml()
    $(document)
      .off('click.zoomService', '.zoom-service .zoom-mines')
      .on('click.zoomService', '.zoom-service .zoom-mines', (event) => {
        event.preventDefault();
        this.decreaseZoom();
      });
    $(document)
      .off('click.zoomService', '.zoom-service .zoom-plus')
      .on('click.zoomService', '.zoom-service .zoom-plus', (event) => {
        event.preventDefault();
        this.increaseZoom();
      });
  }

  decreaseZoom () {
    if (this.zoom <= 1 || this.zoomRelative <= 1) return
    if (this.zoom <= 10) {
      this.zoom-= 1;
    } else {
      this.zoom-= 10;
    }
    this.applyZoom();
    if (window.isBannerBuilder || window.isDisplayBuilder) {
      this.saveZoom();
    }
  }

  increaseZoom() {
    // if (this.zoom >= 100 || this.zoomRelative >= 100) return
    if (this.zoom < 10) {
      this.zoom+= 1;
    } else {
      this.zoom+= 10;
    }
    this.applyZoom();
    if (window.isBannerBuilder || window.isDisplayBuilder) {
      this.saveZoom();
    }
  }

  applyZoom() {
    const appliedZoom = this.appliedZoom;
    $('.zoom-value').html(`${this.zoom}%`);
    
    $(this.containerSelector).each((i, el) => {
      $(el).css({
        scale: appliedZoom / 100,
        transformOrigin: this.transformOrigin,
      });
    });

    //correct action buttons around template list. After removed width 100% to width auto need to correct action buttons position
    const templateWidth = $('.template-list')?.width();
    let right = templateWidth - (templateWidth * (100 / this.zoom));
    
    if (!right) {
      right = 5;
    } else if (right < 0) {
      right -= 20 * (this.zoom / 100)
    }

    if (this.noZoomSelector) {
      const css = `${this.noZoomSelector} { scale: ${100 / appliedZoom}; transform-origin: top right;}`;
      if ($('#noZoomStyle').length) {
        $('#noZoomStyle').text(css);
      } else {
        $('head').append($(`<style id="noZoomStyle">${css}</style>`));
      }
    }
    const s = appliedZoom / 100; // css scale
    window.currentScaleVal = s;
    
    (window.previews || []).forEach(preview => {
      if (preview?.dimension?.[0] > ZoomService.MAX_CANVAS_SIZE || preview?.dimension?.[1] > ZoomService.MAX_CANVAS_SIZE) {
        //resize canvas to update real sizes for big canvases POR-10763 for reference
        try {
          setTimeout(() => {
            handleTemplateZoom(null, preview.id, ZOOM_TYPE.OUT)
            handleTemplateZoom(null, preview.id, ZOOM_TYPE.IN)
          }, 2000)
          
          setTimeout(() => {
            resetZoom(preview.id)
          }, 3000)
        } catch (e) {
          console.error(e)
        }
        
      }
      let canvas = preview.canvas;
      const inv = 1 / s;
      const fabricZoom = canvas.getZoom();

      let updatedCount = 0;
      canvas.getObjects().forEach(obj => {
        if (obj.selectable !== false) {
          // Don't modify cornerSize at all - preserve the size set in new_template.js
          // This keeps handles at constant size regardless of zoom level
          obj.setCoords();
          updatedCount++;
        }
      });
      canvas.requestRenderAll();
    })

    this.onZoom?.();

    return this;
  }

  appendHtml () {
    if (window.isDisplayBuilder) {
      return;
    }

    if (window.isBannerBuilder) {
      $('.zoom-service').html(`
      <div class="d-inline-flex align-items-center justify-content-center" style="width: 110px;">
        <button type="button" class="btn btn-outline-custom p-1 primary mx-0 zoom-mines border-0" title="zoom -" style="background-color: #F6F7F9 !important;padding: 7px !important;width: 100%;border: none !important;">
          <i class="bi bi-zoom-out" style="max-height: 20px; color: #11182A;"></i>
        </button>
        <div class="zoom-value" style="padding: 0 5px;">100%</div>
        <button type="button" class="btn btn-outline-custom p-1 mx-0 zoom-plus border-0" title="zoom +" style="background-color: #F6F7F9 !important;padding: 7px !important;width: 100%;border: none !important;">
          <i class="bi bi-zoom-in" style="max-height: 20px; color: #11182A;"></i>
        </button>
      </div>
      `)

      return;
    }

    $('.zoom-service').html(`
    <div class="d-inline-flex align-items-center justify-content-center" style="width: 90px;">
      <button type="button" class="d-flex btn btn-outline-custom p-1 primary mx-0 zoom-mines border-0" title="zoom -">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#050B19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-zoom-out" style="width: 15px; height: 15px;">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" x2="16.65" y1="21" y2="16.65"></line>
          <line x1="8" x2="14" y1="11" y2="11"></line>
        </svg>
      </button>
      <div class="zoom-value font-xs" style="width: 2.5rem;text-align:center;">100%</div>
      <button type="button" class="d-flex btn btn-outline-custom p-1 mx-0 zoom-plus border-0" title="zoom +">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#050B19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-zoom-in" style="width: 15px; height: 15px;"><circle cx="11" cy="11" r="8"></circle><line x1="21" x2="16.65" y1="21" y2="16.65"></line><line x1="11" x2="11" y1="8" y2="14"></line><line x1="8" x2="14" y1="11" y2="11"></line></svg>
      </button>
    </div>
    `)
  }

  saveZoom() {
    const storageKey = this.getStorageKey();
    if (!storageKey) {
      return;
    }

    localStorage.setItem(storageKey, this.zoom);
  }

  restoreZoom() {
    if (!window.isBannerBuilder && !window.isDisplayBuilder) {
      return;
    }

    const storageKey = this.getStorageKey();
    if (!storageKey) {
      return;
    }

    const savedZoom = Number.parseInt(localStorage.getItem(storageKey), 10);
    if (Number.isFinite(savedZoom) && savedZoom > 0) {
      this.zoom = savedZoom;
    }
  }
}
